import { render, staticRenderFns } from "./BannerHistoryModal.vue?vue&type=template&id=4b9d35de&"
import script from "./BannerHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./BannerHistoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports